"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AssetsPage = AssetsPage;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("@heroui/react");
var react_2 = require("@iconify/react");
var react_3 = require("react");
var react_router_dom_1 = require("react-router-dom");
var message_1 = require("../../../components/dialogs/message");
var onboarding_gaps_prompt_1 = require("../../../components/onboarding-gaps-prompt");
var table_styles_1 = require("../../../components/table-styles");
var building_1 = require("../../../features/apis/building");
var client_1 = require("../../../features/apis/client");
var content_dialog_1 = require("../../../features/thunks/content-dialog");
var message_dialog_1 = require("../../../features/thunks/message-dialog");
var hooks_1 = require("../../../store/hooks");
var format_date_1 = require("../../../utils/format-date");
var to_title_case_1 = require("../../../utils/to-title-case");
var add_building_form_1 = require("./add-building-form");
var constants_1 = require("./constants");
var sync_progress_dialog_1 = require("./sync-progress-dialog");
var sourceFilterOptions = [
    { key: "all", label: "All Sources" },
    { key: "DIGITAL_TWIN", label: "Digital Twin" },
    { key: "MANUAL", label: "Manual" },
    { key: "IMPORT", label: "Import" },
];
function AssetsPage() {
    var _this = this;
    var _a, _b;
    var dispatch = (0, hooks_1.useAppDispatch)();
    var navigate = (0, react_router_dom_1.useNavigate)();
    var _c = (0, hooks_1.useAppSelector)(function (state) { return state.auth; }), clientId = _c.clientId, userId = _c.userId;
    var createBuilding = (0, building_1.useCreateBuildingMutation)()[0];
    var deleteBuilding = (0, building_1.useDeleteBuildingMutation)()[0];
    var clientData = (0, client_1.useFetchClientQuery)(clientId, { skip: !clientId }).data;
    var isDTActive = (0, react_3.useMemo)(function () {
        var _a, _b, _c;
        var configs = (_c = (_b = (_a = clientData === null || clientData === void 0 ? void 0 : clientData.content) === null || _a === void 0 ? void 0 : _a.integrationSettings) === null || _b === void 0 ? void 0 : _b.configurations) !== null && _c !== void 0 ? _c : [];
        return configs.some(function (c) { return c.type === "DIGITAL_TWIN" && c.status === "ACTIVE"; });
    }, [clientData]);
    var _d = (0, react_3.useState)(""), searchQuery = _d[0], setSearchQuery = _d[1];
    var _e = (0, react_3.useState)(""), debouncedSearch = _e[0], setDebouncedSearch = _e[1];
    var _f = (0, react_3.useState)("all"), statusFilter = _f[0], setStatusFilter = _f[1];
    var _g = (0, react_3.useState)("all"), typeFilter = _g[0], setTypeFilter = _g[1];
    var _h = (0, react_3.useState)("all"), sourceFilter = _h[0], setSourceFilter = _h[1];
    var _j = (0, react_3.useState)(""), ownerNameFilter = _j[0], setOwnerNameFilter = _j[1];
    var _k = (0, react_3.useState)(""), debouncedOwnerName = _k[0], setDebouncedOwnerName = _k[1];
    var _l = (0, react_3.useState)(1), page = _l[0], setPage = _l[1];
    var _m = (0, react_3.useState)(10), rowsPerPage = _m[0], setRowsPerPage = _m[1];
    // Debounce search input to avoid excessive API calls
    (0, react_3.useEffect)(function () {
        var timer = setTimeout(function () {
            setDebouncedSearch(searchQuery);
            setPage(1);
        }, 400);
        return function () { return clearTimeout(timer); };
    }, [searchQuery]);
    (0, react_3.useEffect)(function () {
        var timer = setTimeout(function () {
            setDebouncedOwnerName(ownerNameFilter);
            setPage(1);
        }, 400);
        return function () { return clearTimeout(timer); };
    }, [ownerNameFilter]);
    // Server-side search, filter, and pagination
    var _o = (0, building_1.useSearchBuildingsQuery)({
        clientId: clientId,
        search: debouncedSearch || undefined,
        type: typeFilter !== "all" ? typeFilter : undefined,
        source: sourceFilter !== "all" ? sourceFilter : undefined,
        isActive: statusFilter === "active" ? true : statusFilter === "inactive" ? false : undefined,
        ownerName: debouncedOwnerName || undefined,
        page: page,
        limit: rowsPerPage,
    }, { skip: !clientId, refetchOnMountOrArgChange: true }), buildingsData = _o.data, isLoading = _o.isLoading, isFetching = _o.isFetching, refetch = _o.refetch;
    var buildings = (0, react_3.useMemo)(function () { var _a; return ((_a = buildingsData === null || buildingsData === void 0 ? void 0 : buildingsData.content) === null || _a === void 0 ? void 0 : _a.buildings) || []; }, [buildingsData]);
    var totalItems = ((_b = (_a = buildingsData === null || buildingsData === void 0 ? void 0 : buildingsData.content) === null || _a === void 0 ? void 0 : _a.pagination) === null || _b === void 0 ? void 0 : _b.total) || 0;
    var totalPages = Math.ceil(totalItems / rowsPerPage);
    var handleRefresh = function () {
        refetch();
    };
    var handleSyncFromDT = function () {
        if (!clientId)
            return;
        dispatch((0, content_dialog_1.showContentDialogThunk)({
            header: "Sync From Digital Twin",
            content: (0, jsx_runtime_1.jsx)(sync_progress_dialog_1.SyncProgressDialog, { clientId: clientId, onComplete: function () { return refetch(); } }),
            contentMaxWidth: "max-w-lg",
            isDismissable: false,
        }));
    };
    var handleAddBuilding = function () {
        dispatch((0, content_dialog_1.showContentDialogThunk)({
            header: "Add New Asset",
            content: (0, jsx_runtime_1.jsx)(add_building_form_1.BuildingForm, { onSubmit: handleBuildingSubmit, mode: "create" }),
            contentMaxWidth: "max-w-2xl",
            isDismissable: true,
        }));
    };
    var handleOpenAsset = (0, react_3.useCallback)(function (assetId) {
        navigate("/dashboard/assets/".concat(assetId));
    }, [navigate]);
    var handleDeleteBuilding = (0, react_3.useCallback)(function (buildingId, buildingName) { return __awaiter(_this, void 0, void 0, function () {
        var response, error_1, message;
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    _b.trys.push([0, 3, , 4]);
                    return [4 /*yield*/, dispatch((0, message_dialog_1.showMessageDialogThunk)({
                            header: "Delete Building",
                            body: "Are you sure you want to delete \"".concat(buildingName, "\"? This action cannot be undone."),
                            buttons: [
                                { type: message_1.EMessageDialogButtonType.CANCEL, label: "Cancel", variant: "light" },
                                { type: message_1.EMessageDialogButtonType.OK, label: "Delete", variant: "solid" },
                            ],
                        })).unwrap()];
                case 1:
                    _b.sent();
                    return [4 /*yield*/, deleteBuilding({ buildingId: buildingId, performedBy: userId }).unwrap()];
                case 2:
                    response = _b.sent();
                    if (response.success) {
                        (0, react_1.addToast)({
                            title: "Building Deleted",
                            description: "\"".concat(buildingName, "\" has been deleted successfully."),
                            color: "success",
                        });
                    }
                    else {
                        (0, react_1.addToast)({
                            title: "Delete Failed",
                            description: response.message || "Could not delete building.",
                            color: "danger",
                        });
                    }
                    return [3 /*break*/, 4];
                case 3:
                    error_1 = _b.sent();
                    if (error_1 === "cancel")
                        return [2 /*return*/];
                    message = ((_a = error_1 === null || error_1 === void 0 ? void 0 : error_1.data) === null || _a === void 0 ? void 0 : _a.message) || "An error occurred while deleting the building.";
                    (0, react_1.addToast)({
                        title: "Delete Failed",
                        description: message,
                        color: "danger",
                    });
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); }, [dispatch, deleteBuilding]);
    var handleBuildingSubmit = function (data) { return __awaiter(_this, void 0, void 0, function () {
        var response, error_2, message;
        var _a, _b, _c;
        return __generator(this, function (_d) {
            switch (_d.label) {
                case 0:
                    _d.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, createBuilding({
                            clientId: clientId,
                            createdBy: userId,
                            name: data.name,
                            code: data.code,
                            type: data.type,
                            description: data.description,
                            floors: data.floors,
                            source: data.source,
                            isActive: data.isActive,
                            development: data.development,
                            billingSettings: data.billingSettings,
                            address: {
                                fullAddress: data.address.fullAddress,
                                coordinates: {
                                    lat: ((_a = data.address.coordinates) === null || _a === void 0 ? void 0 : _a.lat) || 0,
                                    lng: ((_b = data.address.coordinates) === null || _b === void 0 ? void 0 : _b.lng) || 0,
                                },
                            },
                            buildingId: data.buildingId,
                            tags: data.tags,
                            gla: data.gla,
                            lsm: data.lsm,
                            areaCodeSuffixDigits: data.areaCodeSuffixDigits,
                            assetManagerId: data.assetManagerId,
                            utilitiesManagerId: data.utilitiesManagerId,
                            buildingAccountantId: data.buildingAccountantId,
                            leasingManagerId: data.leasingManagerId,
                            operationsManagerId: data.operationsManagerId,
                            buildingManagerId: data.buildingManagerId,
                        }).unwrap()];
                case 1:
                    response = _d.sent();
                    if (response.success) {
                        (0, react_1.addToast)({
                            title: "Building Created",
                            description: "\"".concat(data.name, "\" has been created successfully."),
                            color: "success",
                        });
                        return [2 /*return*/, true];
                    }
                    else {
                        (0, react_1.addToast)({
                            title: "Create Failed",
                            description: response.message || "Could not create building.",
                            color: "danger",
                        });
                        return [2 /*return*/, false];
                    }
                    return [3 /*break*/, 3];
                case 2:
                    error_2 = _d.sent();
                    message = ((_c = error_2 === null || error_2 === void 0 ? void 0 : error_2.data) === null || _c === void 0 ? void 0 : _c.message) || "An error occurred while creating the building.";
                    (0, react_1.addToast)({
                        title: "Create Failed",
                        description: message,
                        color: "danger",
                    });
                    return [2 /*return*/, false];
                case 3: return [2 /*return*/];
            }
        });
    }); };
    var handleRowsPerPageChange = function (keys) {
        if (keys !== "all") {
            var value = Array.from(keys)[0];
            setRowsPerPage(Number(value));
            setPage(1);
        }
    };
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    var renderCell = (0, react_3.useCallback)(function (building, columnKey) {
        var _a, _b, _c;
        switch (columnKey) {
            case "name":
                return (0, jsx_runtime_1.jsx)("span", { className: "font-medium text-gray-900", children: (0, to_title_case_1.toTitleCase)(building.name) });
            case "code":
                return ((0, jsx_runtime_1.jsx)(react_1.Chip, { size: "sm", variant: "flat", color: "primary", className: "font-mono", children: building.code }));
            case "ownerName":
                return (0, jsx_runtime_1.jsx)("span", { className: "text-sm text-gray-700", children: ((_a = building.owner) === null || _a === void 0 ? void 0 : _a.tradingAsName) || ((_b = building.owner) === null || _b === void 0 ? void 0 : _b.companyName) || "—" });
            case "description":
                return (0, jsx_runtime_1.jsx)("span", { className: "line-clamp-2 max-w-xs text-sm text-gray-600", children: building.description || "—" });
            case "type": {
                var typeColors = {
                    RETAIL: "secondary",
                    OFFICE: "primary",
                    COMMERCIAL: "warning",
                    RESIDENTIAL: "success",
                    INDUSTRIAL: "danger",
                    MINING: "default",
                    HOTEL: "primary",
                    HOTELS: "primary",
                    MIXED_USE: "warning",
                    SPORT_CENTRES: "success",
                };
                var typeLabels = {
                    RETAIL: "Retail",
                    OFFICE: "Office",
                    COMMERCIAL: "Commercial",
                    RESIDENTIAL: "Residential",
                    INDUSTRIAL: "Industrial",
                    MINING: "Mining",
                    HOTEL: "Hotel",
                    HOTELS: "Hotels",
                    MIXED_USE: "Mixed Use",
                    SPORT_CENTRES: "Sport Centres",
                };
                return ((0, jsx_runtime_1.jsx)(react_1.Chip, { size: "sm", variant: "flat", color: typeColors[building.type] || "default", children: typeLabels[building.type] || building.type }));
            }
            case "source":
                return (0, jsx_runtime_1.jsx)("span", { className: "text-sm text-gray-700", children: building.source || "—" });
            case "defaultBillingDate":
                return ((0, jsx_runtime_1.jsx)("span", { className: "text-sm text-gray-700", children: ((_c = building.billingSettings) === null || _c === void 0 ? void 0 : _c.defaultBillingDate) ? "Day ".concat(building.billingSettings.defaultBillingDate) : "—" }));
            case "status":
                return ((0, jsx_runtime_1.jsx)(react_1.Chip, { size: "sm", variant: "flat", color: building.isActive ? "success" : "danger", children: building.isActive ? "Active" : "Inactive" }));
            case "createdAt":
                return (0, jsx_runtime_1.jsx)("span", { className: "text-sm text-gray-500", children: (0, format_date_1.formatDate)(building.createdAt) });
            case "updatedAt":
                return (0, jsx_runtime_1.jsx)("span", { className: "text-sm text-gray-500", children: (0, format_date_1.formatDate)(building.updatedAt) });
            case "actions":
                return ((0, jsx_runtime_1.jsxs)("div", { className: "flex items-center gap-1", children: [(0, jsx_runtime_1.jsx)(react_1.Button, { isIconOnly: true, size: "sm", variant: "light", onPress: function () { return handleOpenAsset(building._id); }, children: (0, jsx_runtime_1.jsx)(react_2.Icon, { icon: "solar:eye-linear", className: "text-lg text-gray-500" }) }), (0, jsx_runtime_1.jsx)(react_1.Button, { isIconOnly: true, size: "sm", variant: "light", onPress: function () { return handleDeleteBuilding(building._id, building.name); }, children: (0, jsx_runtime_1.jsx)(react_2.Icon, { icon: "solar:trash-bin-trash-linear", className: "text-lg text-red-500" }) })] }));
            default:
                return null;
        }
    }, [handleOpenAsset, handleDeleteBuilding]);
    return ((0, jsx_runtime_1.jsxs)("div", { className: "flex flex-col gap-4 md:gap-6", children: [(0, jsx_runtime_1.jsxs)("div", { className: "rounded-xl bg-white p-4 shadow-sm md:p-6", children: [(0, jsx_runtime_1.jsxs)("div", { className: "flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-between", children: [(0, jsx_runtime_1.jsx)("h1", { className: "text-xl font-semibold text-gray-900 md:text-2xl", children: "Assets Management" }), (0, jsx_runtime_1.jsxs)("div", { className: "flex items-center gap-2", children: [(0, jsx_runtime_1.jsx)(react_1.Button, { color: "primary", startContent: (0, jsx_runtime_1.jsx)(react_2.Icon, { icon: "solar:add-circle-linear", className: "text-lg" }), onPress: handleAddBuilding, className: "flex-1 sm:flex-none", children: "Add Asset" }), (0, jsx_runtime_1.jsx)(react_1.Button, { variant: "bordered", color: "primary", startContent: (0, jsx_runtime_1.jsx)(react_2.Icon, { icon: "solar:cloud-download-linear", className: "text-lg" }), onPress: handleSyncFromDT, isDisabled: !isDTActive, className: "flex-1 sm:flex-none", children: "Sync From DT" }), (0, jsx_runtime_1.jsx)(react_1.Button, { isIconOnly: true, variant: "light", onPress: handleRefresh, children: (0, jsx_runtime_1.jsx)(react_2.Icon, { icon: "solar:refresh-linear", className: "text-xl text-gray-600" }) })] })] }), (0, jsx_runtime_1.jsxs)("div", { className: "mt-4 flex flex-col gap-4 md:mt-6", children: [(0, jsx_runtime_1.jsxs)("div", { className: "grid grid-cols-1 gap-3 sm:grid-cols-2 lg:grid-cols-4", children: [(0, jsx_runtime_1.jsx)(react_1.Input, { className: "sm:col-span-2 lg:col-span-1", placeholder: "Search assets...", startContent: (0, jsx_runtime_1.jsx)(react_2.Icon, { icon: "solar:magnifer-linear", className: "text-gray-400" }), value: searchQuery, onValueChange: setSearchQuery, variant: "bordered", size: "lg" }), (0, jsx_runtime_1.jsx)(react_1.Select, { disableAnimation: true, label: "Status", placeholder: "Select status", variant: "bordered", size: "sm", selectedKeys: [statusFilter], onSelectionChange: function (keys) {
                                            if (keys !== "all") {
                                                var value = Array.from(keys)[0];
                                                setStatusFilter(value);
                                                setPage(1);
                                            }
                                        }, listboxProps: { className: "max-h-[200px] overflow-auto" }, children: constants_1.statusOptions.map(function (status) { return ((0, jsx_runtime_1.jsx)(react_1.SelectItem, { children: status.label }, status.key)); }) }), (0, jsx_runtime_1.jsx)(react_1.Select, { disableAnimation: true, label: "Building Type", placeholder: "Select type", variant: "bordered", size: "sm", selectedKeys: [typeFilter], onSelectionChange: function (keys) {
                                            if (keys !== "all") {
                                                var value = Array.from(keys)[0];
                                                setTypeFilter(value);
                                                setPage(1);
                                            }
                                        }, listboxProps: { className: "max-h-[200px] overflow-auto" }, children: constants_1.buildingTypeOptions.map(function (buildingType) { return ((0, jsx_runtime_1.jsx)(react_1.SelectItem, { children: buildingType.label }, buildingType.key)); }) }), (0, jsx_runtime_1.jsx)(react_1.Select, { disableAnimation: true, label: "Source", placeholder: "Select source", variant: "bordered", size: "sm", selectedKeys: [sourceFilter], onSelectionChange: function (keys) {
                                            if (keys !== "all") {
                                                var value = Array.from(keys)[0];
                                                setSourceFilter(value);
                                                setPage(1);
                                            }
                                        }, listboxProps: { className: "max-h-[200px] overflow-auto" }, children: sourceFilterOptions.map(function (option) { return ((0, jsx_runtime_1.jsx)(react_1.SelectItem, { children: option.label }, option.key)); }) }), (0, jsx_runtime_1.jsx)(react_1.Input, { size: "sm", variant: "bordered", placeholder: "Building Owner...", className: "w-48", startContent: (0, jsx_runtime_1.jsx)(react_2.Icon, { icon: "solar:user-rounded-linear", className: "text-gray-400" }), value: ownerNameFilter, onValueChange: setOwnerNameFilter, isClearable: true, onClear: function () { return setOwnerNameFilter(""); } })] }), (0, jsx_runtime_1.jsxs)("div", { className: "flex items-center gap-2 text-sm text-gray-500", children: ["Total Assets: ", (0, jsx_runtime_1.jsx)("span", { className: "font-semibold text-gray-700", children: totalItems }), isFetching && !isLoading && (0, jsx_runtime_1.jsx)(react_1.Spinner, { size: "sm" })] })] })] }), (0, jsx_runtime_1.jsx)(onboarding_gaps_prompt_1.OnboardingGapsPrompt, {}), (0, jsx_runtime_1.jsx)("div", { className: "overflow-hidden rounded-xl bg-white shadow-sm", children: (0, jsx_runtime_1.jsx)("div", { className: "overflow-x-auto", children: (0, jsx_runtime_1.jsxs)(react_1.Table, { "aria-label": "Buildings table", classNames: table_styles_1.DATA_TABLE_CLASS_NAMES, bottomContent: (0, jsx_runtime_1.jsxs)("div", { className: "flex w-full flex-col gap-3 border-t border-gray-100 px-3 py-3 sm:flex-row sm:items-center sm:justify-between sm:px-4 sm:py-4", children: [(0, jsx_runtime_1.jsxs)("span", { className: "text-center text-xs text-gray-500 sm:text-left sm:text-sm", children: ["Showing ", totalItems === 0 ? 0 : (page - 1) * rowsPerPage + 1, " to ", Math.min(page * rowsPerPage, totalItems), " of ", totalItems] }), (0, jsx_runtime_1.jsxs)("div", { className: "flex flex-col items-center gap-3 sm:flex-row sm:gap-4", children: [(0, jsx_runtime_1.jsxs)("div", { className: "flex items-center gap-2", children: [(0, jsx_runtime_1.jsx)("span", { className: "text-xs text-gray-500 sm:text-sm", children: "Rows:" }), (0, jsx_runtime_1.jsx)(react_1.Select, { className: "w-16 sm:w-20", size: "sm", variant: "bordered", selectedKeys: [String(rowsPerPage)], onSelectionChange: handleRowsPerPageChange, "aria-label": "Rows per page", children: constants_1.rowsPerPageOptions.map(function (option) { return ((0, jsx_runtime_1.jsx)(react_1.SelectItem, { children: option.label }, option.key)); }) })] }), totalPages > 1 && ((0, jsx_runtime_1.jsx)(react_1.Pagination, { isCompact: true, showControls: true, showShadow: true, color: "primary", page: page, total: totalPages, onChange: setPage, size: "sm" }))] })] }), children: [(0, jsx_runtime_1.jsx)(react_1.TableHeader, { columns: constants_1.columns, children: function (column) { return ((0, jsx_runtime_1.jsx)(react_1.TableColumn, { align: column.uid === "actions" ? "center" : "start", children: column.name }, column.uid)); } }), (0, jsx_runtime_1.jsx)(react_1.TableBody, { items: buildings, emptyContent: isLoading || isFetching ? " " : "No buildings found", isLoading: isLoading || isFetching, loadingContent: (0, jsx_runtime_1.jsx)(react_1.Spinner, { label: "Loading buildings..." }), children: function (item) { return (0, jsx_runtime_1.jsx)(react_1.TableRow, { children: function (columnKey) { return (0, jsx_runtime_1.jsx)(react_1.TableCell, { children: renderCell(item, columnKey) }); } }, item._id); } })] }) }) })] }));
}
